import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

type TypeChangePolicyReConsentParams = {
  /** 채용 정보 문자 수신 동의 여부 */
  allowRecruit: boolean;
  /** 야간 채용 안내 문자 수신 동의 여부 */
  allowNightTime: boolean;
};

type TypeChangePolicyReConsentResponse = {
  code: string;
  message: string;
};

/** @description 변경된 이용 약관 재동의 api에 사용되는 커스텀 훅 */
export const useChangePolicyReConsent = () => {
  const { mutateAsync } = useMutation({
    mutationFn: (params: TypeChangePolicyReConsentParams) => {
      const endpoint = '/labor-accounts/re-consent';
      return axiosInstance.put(endpoint, params);
    },
  });

  const requestChangePolicyReConsent = async ({
    params,
    onSuccess,
    onError,
    onFinally,
  }: {
    params: TypeChangePolicyReConsentParams;
    onSuccess?: (res: TypeChangePolicyReConsentResponse) => void;
    onError?: (err: TypeErrorFormat) => void;
    onFinally?: () => void;
  }) => {
    requestHelper(() => mutateAsync(params), onSuccess, onError, onFinally);
  };

  return requestChangePolicyReConsent;
};
